import { defineStyleConfig } from '@chakra-ui/react';

export const Tag = defineStyleConfig({
  baseStyle: {
    container: {
      borderRadius: 'full',
      fontFamily: 'body',
    },
  },
});
